<template>
  <div id="compareTree" >
    <el-container class="layout-container" >
      <!--头部信息-->
      <el-header class="el-header" >
        <div class="title">
          <span>ARENA</span>
        </div>

<!--        active-text-color="#B46C03"-->
<!--        active-text-color="#D17C00"-->
        <div class="compareTreeMenu" >
          <el-menu class="el-menu"
                   background-color="#C6E2FF"
                   active-text-color="#606266"
                   mode="horizontal"
                   >
            <el-submenu index="1">
              <template slot="title">Setting</template>
              <el-menu-item class="compareTreeMenu" index="1-1">
                <el-switch v-model="showDiff" active-text="Show Difference Info"></el-switch>
              </el-menu-item>
              <el-menu-item class="compareTreeMenu" index="1-1">
                <el-switch v-model="showToolTip" active-text="Show ToolTip"></el-switch>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </el-header>
      <!--      主题信息-->
      <el-container>
      <el-aside width="300px"  style="height: 90vh" v-show="showDiff">
        <el-collapse class="my-collapse" v-model="activeName">
<!--          展示表扫描方式的差异-->
          <el-collapse-item title="SCAN DIFFERENCE" name="1">
            <div v-if="! isScanDiff">
              The scan operation of tables is same.
            </div>
            <div v-if="isScanDiff" class="diffTable">
              <el-tooltip class="item" effect="dark" content="Click to locate the operator" placement="top" hide-after="2000" :disabled="!showToolTip">
                <el-table :data="scanTableData"
                        style="width: 100%"
                        highlight-current-row
                        @row-click="tableRowSelect"
                        :default-sort="{prop:'name'}" >
                  <el-table-column prop="name" label="Name"></el-table-column>
                  <el-table-column prop="qep" label="QEP"></el-table-column>
                  <el-table-column prop="ap" label="AP"></el-table-column>
              </el-table>
              </el-tooltip>
            </div>
          </el-collapse-item>

<!--          展示表连接方式的差异-->
          <el-collapse-item title="JOIN DIFFERENCE" name="2" v-if="isJoinDiff">
            <div v-if="isJoinDiff === 1">
              The join operation of tables is same.
            </div>
            <div v-if="isJoinDiff === 2">
              The join tree structure is different.
            </div>
            <div v-if="isJoinDiff === 3" class="diffTable">
              <el-tooltip class="item" effect="dark" placement="top" hide-after="4000" :disabled="!showToolTip">
                <div slot="content">Click '>' to show more info. <br><br> Click row to locate the operator.</div>
                <el-table :data="joinTableData"
                          style="width: 100%"
                          highlight-current-row
                          @row-click="tableRowSelect"
                          :default-sort="{prop:'order'}" >
                  <el-table-column type="expand">
                    <template v-slot="props">
                      <el-form label-position="left" inline class="demo-table-expand">
                        <el-form-item label="QEP">
                          <span>{{ props.row.qep }}</span>
                        </el-form-item>
                        <el-form-item label="AP">
                          <span>{{ props.row.ap }}</span>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-table-column>
                  <el-table-column prop="order" label="Order"></el-table-column>
                  <el-table-column prop="message" label="Description" width="170px"></el-table-column>
                </el-table>
              </el-tooltip>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-aside>
        <el-main >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card>
            <div>
              <div style="width: calc(100% - 10px);height:calc(100vh - 140px);">
                <SeeksRelationGraph ref="bestRelationGraph" :options="graphOptions" :on-node-click="handleClickNode"/>
              </div>
            </div>
              <div style="text-align: center; font-size: large; color: #409EFF;">
                Best Plan (QEP)
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card>
            <div>
              <div style="width: calc(100% - 10px);height:calc(100vh - 140px);">
                <SeeksRelationGraph ref="selectedRelationGraph" :options="graphOptions" :on-node-click="handleClickNode"/>
              </div>
            </div>
              <div style="text-align: center; font-size: large; color: #409EFF;">
                Alternative Plan (AP): {{planId}}
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import SeeksRelationGraph from 'relation-graph'
export default {
  name: "CompareTree",
  components: { SeeksRelationGraph },
  data() {
    return {
      data_index: this.$route.query.index,
      data_buffer: null,
      planId:null,  // 选择的与 bestPlan 进行比较的 planId
      showDiff: true,  // 是否展示两个 Plan 之间的差别
      showToolTip: true,  // 是否显示 tool tip 的信息
      isScanDiff: false,  // 两个 plan 之间的 scan 方式是否有差别
      isJoinDiff: 1, // 两个 plan 之间连接方式是否有差异
      scanTableData: [], // 用于绘制 plan 扫描方式差异的表信息 是一个对象组成的数组，每个对象包含如下键：name, qep, ap
      joinTableData: [], // 用于绘制 plan 连接方式差异的表信息 是一个对象组成的数组，每个对象包含如下键：order, message, qep, ap
      activeName: ["1", "2"],
      graphOptions: {
        'layouts': [
          {
            'label': '中心',
            'layoutName': 'tree',
            'defaultJunctionPoint': 'border',
            'defaultNodeShape': 0,
            'defaultLineShape': 1,
            'centerOffset_y': -150,
            'min_per_width': '60',
            'min_per_height': '150',
            'max_per_height': '300'
          }
        ],
        "defaultExpandHolderPosition": "bottom",
        'defaultLineShape': 4,
        'defaultJunctionPoint': 'tb',
        'defaultNodeShape': 1,
        'defaultNodeWidth': '50',
        'defaultNodeHeight': '250',
        'defaultNodeBorderWidth': 0,
        'defaultNodeColor': "#f8e3c5",
        'defaultNodeFontColor': '#606266',
        'defaultLineColor': '#606266',
        'moveToCenterWhenResize': false,
        'allowShowMiniNameFilter': false,
      }
    }
  },
  mounted() {
    let isDiffColor;
    if (this.data_buffer == null){
     this.data_buffer = JSON.parse(localStorage[this.data_index]);
     console.log("树的信息为：", this.data_buffer)
     isDiffColor = localStorage[this.data_index+"diffColor"];
     isDiffColor = (isDiffColor === "true");

     localStorage.removeItem(this.data_index);
     localStorage.removeItem(this.data_index+"diffColor");
    }

    // 选择的 plan 的 id
    let temp = this.data_index.split('_')  // index 格式为：时间戳_SQLFileName_id
    this.planId = temp[temp.length-1]

    // 设置差异信息
    this.setDiffInfo(this.data_buffer[0], this.data_buffer[1]);

    // 设置不同的颜色
    this.setDiffColor(this.data_buffer[0], isDiffColor);
    this.setDiffColor(this.data_buffer[1], isDiffColor);

    // 绘制 best plan 的结构
    setTimeout(function() {
      this.$refs.bestRelationGraph.setJsonData(this.data_buffer[0], (seeksRGGraph) => {
        // 这些写上当图谱初始化完成后需要执行的代码
      })
    }.bind(this), 1000);

    // 绘制 selected plan 的结构
    setTimeout(function() {
      this.$refs.selectedRelationGraph.setJsonData(this.data_buffer[1], (seeksRGGraph) => {
        // 这些写上当图谱初始化完成后需要执行的代码
      })
    }.bind(this), 1000);
  },

  methods: {
    clearStorage() {
      localStorage.clear();
    },

    tableRowSelect(row) {
      // 设置图中被选中的状态
      this.$refs.bestRelationGraph.focusNodeById(row["qepId"]);
      this.$refs.selectedRelationGraph.focusNodeById(row["apId"]);
    },

    /**
     * 处理节点的点击事件，如果节点有额外信息，即 info 不为空，展示该信息
     * @param nodeObject 被点击的节点对象
     */
    handleClickNode(nodeObject, $event){
      if(localStorage.getItem("isEarlyAccess") === "false"){
        return;
      }

      if (nodeObject.data.info !== '' && nodeObject.data.info !== undefined){
        this.$notify({
          title: 'Index Info',
          message: nodeObject.data.info,
          duration:10000
        })
      }
    },

    /**
     * 设置两个 plan 之间的差异信息
     * @param {Object} bestPlan 最优计划的计划树，它是 table 中每一行对应的 tree 对象
     * @param {Object} ap 候选计划的计划书，与 betPlan 的类型相同
     */
    setDiffInfo(bestPlan, ap) {
      // 首先设置表扫描方式的差别
      let bestScan = bestPlan.diffInfo.scanInfo;
      let apScan = ap.diffInfo.scanInfo;
      for(let key in bestScan) {
        if (bestScan[key][0] !== apScan[key][0]) {  // 某个表的扫描方式不同
          this.isScanDiff = true;
          this.scanTableData.push({name: key, qep: bestScan[key][0], "ap": apScan[key][0], "qepId": bestScan[key][1], "apId": apScan[key][1]});
        }
      }

      // 设置表连接方式的差异
      // 连接的差异涉及三个层次：
      //    1、连接的子表是否相同
      //    2、子表相同后，连接顺序是否相同
      //    3、连接顺序也相同后，连接方法是否相同
      let tempJoinChild = {};  // 记录每个节点连接的子节点，key：id  value: Object{left: set(), right: set()}
      let bestLevel = bestPlan.diffInfo.joinInfo.level
      let bestChild = bestPlan.diffInfo.joinInfo.map
      let apLevel = ap.diffInfo.joinInfo.level
      let apChild = ap.diffInfo.joinInfo.map

      if(Object.keys(bestLevel).length === 0){  // 不包含 join 操作
        return;
      }

      // 判断 join 的 tree 结构是否相同，当前采用的方法较为简单：(比较 level 中 节点个数是否相同，如果不同，则一定结构不同)，后续可以用更为详细准确的算法
      if (Object.keys(bestLevel).length !== Object.keys(apLevel).length) {
        this.isJoinDiff = 2;
        return;
      } else {
        for (let key in bestLevel) {
          if (bestLevel[key].length !== apLevel[key].length) {
            this.isJoinDiff = 2;
            return;
          }
        }
      }

      // 遍历每一层
      for (let key in bestLevel) {
        let tempBest = bestLevel[key];
        let tempAp = apLevel[key];
        // 对每一层，遍历所有 join 的 id
        for (let i=0;i<tempBest.length;i++) {
          console.log(key, i)
          let bestId = tempBest[i];
          let apId = tempAp[i];

          // 首先取得该连接涉及的子表
          let bestLeft = bestChild[bestId][0];  // bestLeft 等都是 Id
          let bestRight = bestChild[bestId][1];
          let apLeft = apChild[apId][0];
          let apRight = apChild[apId][1];
          console.log(bestLeft)

          bestLeft = this.getChildTable(bestLeft, tempJoinChild);
          bestRight = this.getChildTable(bestRight, tempJoinChild);
          apLeft = this.getChildTable(apLeft, tempJoinChild);
          apRight = this.getChildTable(apRight, tempJoinChild);

          tempJoinChild[bestId] = {"left": bestLeft, "right": bestRight};
          tempJoinChild[apId] = {"left": apLeft, "right": apRight};

          let order, message, qepLabel, apLabel;
          order = key+'-'+(i+1);
          qepLabel = this.getNameFromId(bestId) + ": ";
          apLabel = this.getNameFromId(apId) + ": ";
          // 首先判断连接的子表是否相同
          if ((this.eqSet(bestLeft, apLeft) && this.eqSet(bestRight, apRight)) ||
               this.eqSet(bestLeft, apRight) && this.eqSet(bestRight, apLeft)) {
            // 再判断子表连接顺序是否相同
            if (this.eqSet(bestLeft, apLeft)) {  // 子表的连接顺序也相同
              // 再判断join的方法是否相同
              if (qepLabel === apLabel){
                continue;  // 这个 join 完全相同，比较下一个即可
              } else {  // 表的 Join 方法不同
                message = "different join operator";
              }
            } else {
              message = "different join order";
            }
          } else {  // 问题在于连接的表不同
            message = "joined table is different";
          }
          qepLabel = qepLabel + this.printSet(bestLeft) + " X " + this.printSet(bestRight);
          apLabel = apLabel + this.printSet(apLeft) + " X " + this.printSet(apRight);

          // 将信息添加到需要绘制表格的结构体中
          this.isJoinDiff = 3;
          this.joinTableData.push({"order": order, "message": message, "qep": qepLabel, "ap": apLabel, "qepId": bestId, "apId": apId });
        }
      }
    },
    eqSet(as, bs) {
      if (as.size !== bs.size) return false;
      for (let a of as) if (!bs.has(a)) return false;
      return true;
    },
    printSet(as) {
      let res = '[ ';
      for (let a of as) {
        res += a;
        res += ' ';
      }
      res += ']';
      return res;
    },
    getNameFromId(tempId) {
      return tempId.split('_')[3];
    },
    typeOfName(tempName) {
      if (tempName.indexOf("Join") !== -1) {
        return "JOIN";
      } else {
        return "TABLE";
      }
    },
    getChildTable(tempId, id2Child) {
      if (this.typeOfName(this.getNameFromId(tempId)) === "JOIN") {
         return new Set([...id2Child[tempId].left, ...id2Child[tempId].right]);
      } else {
        return new Set([this.getNameFromId(tempId)]);
      }
    }
  }
}
</script>

<style scoped>
.layout-container .el-header {
  position: relative;
  background-color: #C6E2FF;
}

.layout-container .title{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 20px;
  color: #303133;
}

.layout-container .compareTreeMenu{
  float: right;
}


</style>

<style>
#compareTree .el-card__body{
  padding: 5px;
}

.compareTreeMenu .el-submenu__title{
  font-size: 16px;
}

.compareTreeMenu .el-switch__label.is-active{
  color: #303133;
}

.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  /*width: 90px;*/
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
}

.diffTable .el-table__row{
  background-color: #FAFAFA !important;
}

.my-collapse .el-collapse-item__wrap{
  border-bottom-color: #C0C4CC !important;
}

.my-collapse .el-collapse-item__header{
  border-bottom-color: #C0C4CC !important;
}

.my-collapse .el-collapse-item__header.is-active{
  border-bottom-color: transparent !important;
}

</style>
